export var getBufferReader = function getBufferReader(response) {
  if (!response.body) {
    throw new Error('Response body is empty');
  }
  return response.body.pipeThrough(new TextDecoderStream()).getReader();
};